var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',_vm._b({},'ul',_vm.$attrs,false),_vm._l((_vm.activeMenuItems),function(menuItem){return _c('side-nav-menu-item',{key:menuItem.routeName,attrs:{"menuItem":menuItem},on:{"click":_vm.closeMenu}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }